import { render, staticRenderFns } from "./pdf_old.vue?vue&type=template&id=47750a56"
import script from "./pdf_old.vue?vue&type=script&lang=js"
export * from "./pdf_old.vue?vue&type=script&lang=js"
import style0 from "./pdf_old.vue?vue&type=style&index=0&id=47750a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports